import {DistinctDomainKeyWithChainIndex} from 'antibodies/AntibodyTypedefs';
import {TranslationParameters} from 'antibodies/nested-data-creation/constants/AntibodyNestedDataCreationConstants';
import * as TaskRunner from 'util/TaskRunner';

export interface DefinedConstantDomainEntity extends DistinctDomainKeyWithChainIndex {
  aaSequenceId: string;
}

export interface NestedCreateAndRegisterAntibodiesInput {
  schemaId: string;
  dnaPairIds: Array<string>;
  constantDomains: Array<DefinedConstantDomainEntity>;
  folderId: string;
  translationParameters: TranslationParameters;
}

/**
 * Creates and registers antibodies from the provided DNA pair IDs.
 *
 * @param dnaPairIds - List of API IDs for DNA pairs to convert to antibodies
 * @param constantDomains - List of which AA sequences to use as the constant domains
 * @param folderId - folder where all new entities will be created
 * @param schemaId - antibody schema API ID
 * @param translationParameters - parameters for translating DNA to amino acids
 */
export function nestedCreateAndRegisterAntibodies({
  dnaPairIds,
  constantDomains,
  folderId,
  schemaId,
  translationParameters,
}: NestedCreateAndRegisterAntibodiesInput): Promise<{createdAllEntities: boolean; ndcWorkspaceUrl?: string}> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/antibodies:nested-create-and-register',
    data: {
      createAntibodiesData: {
        // TODO(BNCH-140459): Update this to send the pipeline request shape instead.
        requestType: 'DEPRECATED_BULK_INGEST_REQUEST',
        dnaPairIds,
        schemaId,
        constantDomains: constantDomains.map((domain) => ({
          type: domain.type,
          specificity: domain.specificity,
          aaSequenceId: domain.aaSequenceId,
        })),
        folderId,
        translationParameters,
      },
    },
  });
}
